<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :fixed-header="true"
      :search="search"
      height="calc(100vh - 290px)"
      class="font-resp-tabela"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Cadastro de Filial Relatório</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>

          <v-spacer></v-spacer>

          <v-text-field
            class="mr-10"
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
          ></v-text-field>
          <v-dialog persistent v-model="dialog" max-width="800px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">Novo</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <v-btn
                color="#000"
                icon
                style="margin-left: -10px"
                @click="close()"
              >
              <v-icon>mdi-close</v-icon>
              </v-btn>
                <span class="headline ml-3">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col class="pa-0" cols="6" xs="12">
                      <v-select
                        label="Selecione uma Filial*"
                        autofocus
                        outlined
                        v-model="editedItem.grupo"
                        :items="selects.grupos"
                        item-value="id"
                        item-text="descricao"
                        :error-messages="grupoErrors"
                        :disabled="editedIndex >= 0 ? true : false"
                        @input="$v.editedItem.grupo.$touch()"
                        @blur="$v.editedItem.grupo.$touch()"
                        @change="buscarFiliais()"
                      ></v-select>
                    </v-col>
                    <v-col class="pa-0 pl-3" cols="6" xs="12">
                      <v-select
                        label="Selecione uma Filial*"
                        outlined
                        v-model="editedItem.filial"
                        :items="selects.filiais"
                        item-value="id"
                        item-text="descricao"
                        :disabled="editedIndex >= 0 ? true : false"
                        :error-messages="filialErrors"
                        @input="$v.editedItem.filial.$touch()"
                        @blur="$v.editedItem.filial.$touch()"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pa-0" cols="6" xs="12">
                      <v-text-field
                        outlined
                        v-model="editedItem.razao_social"
                        label="Informe uma Razão Social*"
                        color="#042333"
                        :error-messages="razaoSocialErrors"
                        @input="$v.editedItem.razao_social.$touch()"
                        @blur="$v.editedItem.razao_social.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-col class="pa-0 pl-3" cols="6" xs="12">
                      <v-text-field
                        outlined
                        v-model="editedItem.cnpj"
                        label="Informe o CNPJ*"
                        color="#042333"
                        v-mask="maskCnpj"
                        :error-messages="cnpjErrors"
                        @input="$v.editedItem.cnpj.$touch()"
                        @blur="$v.editedItem.cnpj.$touch()"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pa-0" cols="6" xs="12">
                      <v-text-field
                        outlined
                        v-model="editedItem.endereco"
                        label="Informe o Endereco*"
                        color="#042333"
                        :error-messages="enderecoErrors"
                        @input="$v.editedItem.endereco.$touch()"
                        @blur="$v.editedItem.endereco.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-col class="pa-0 pl-3" cols="6" xs="12">
                      <v-text-field
                        outlined
                        v-model="editedItem.cep"
                        label="Informe a CEP*"
                        color="#042333"
                        v-mask="maskCep"
                        :error-messages="cepErrors"
                        @input="$v.editedItem.cep.$touch()"
                        @blur="$v.editedItem.cep.$touch()"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pa-0" cols="6" xs="12">
                      <v-text-field
                        outlined
                        v-model="editedItem.cidade"
                        label="Informe a Cidade*"
                        color="#042333"
                        :error-messages="cidadeErrors"
                        @input="$v.editedItem.cidade.$touch()"
                        @blur="$v.editedItem.cidade.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-col class="pa-0 pl-3" cols="6" xs="12">
                      <v-text-field
                        outlined
                        v-model="editedItem.estado"
                        label="Informe UF do estado*"
                        color="#042333"
                        v-mask="maskUf"
                        :error-messages="estadoErrors"
                        @input="$v.editedItem.estado.$touch()"
                        @blur="$v.editedItem.estado.$touch()"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pa-0" cols="6" xs="12">
                      <v-text-field
                        outlined
                        v-model="editedItem.inscricao_estadual"
                        label="Informe a Inscrição Estadual*"
                        color="#042333"
                        :error-messages="ieErrors"
                        @input="$v.editedItem.inscricao_estadual.$touch()"
                        @blur="$v.editedItem.inscricao_estadual.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-col class="pa-0 pl-3" cols="6" xs="12">
                      <v-text-field
                        outlined
                        v-model="editedItem.suframa"
                        label="Informe Suframa*"
                        color="#042333"
                        :error-messages="suframaErrors"
                        @input="$v.editedItem.suframa.$touch()"
                        @blur="$v.editedItem.suframa.$touch()"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="close">Sair</v-btn>
                <v-btn color="blue darken-1" text @click="save">Salvar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon title="Editar Módulo" class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon title="Remover Módulo" @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import ConfigApi from "./../../api/cfg";
import DrpAPI from "./../../api/drp";

export default {
  data: () => ({
    dialog: false,
    search: "",
    headers: [
      { text: "Filial", value: "idfilial" },
      { text: "Razão  Social", value: "razao_social" },
      { text: "CNPJ", value: "cnpj" },
      { text: "Estado", value: "estado" },
      { text: "Cidade", value: "cidade" },
      { text: "Endereço", value: "endereco" },
      { text: "Cep", value: "cep" },
      { text: "Inscrição Estadual", value: "inscricao_estadual" },
      { text: "Suframa", value: "suframa" },
      { text: "Ações", value: "action", sortable: false },
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      grupo: "",
      filial: "",
      razao_social: "",
      cnpj: "",
      endereco: "",
      cidade: "",
      estado: "",
      inscricao_estadual: "",
      cep: "",
      suframa: "",
    },
    selects: {
      grupos: [],
      filiais: [],
    },
    maskCnpj: "##.###.###/####-##",
    maskCep: "#####-###",
    maskUf: "AA",
  }),

  validations: {
    editedItem: {
      grupo: { required },
      filial: { required },
      razao_social: { required },
      cnpj: { required },
      endereco: { required },
      cidade: { required },
      estado: { required },
      inscricao_estadual: { required },
      cep: { required },
      suframa: { required },
    },
  },

  created() {
    this.initialize();
    this.buscarGrupos();
  },

  computed: {
    grupoErrors() {
      const errors = [];
      if (!this.$v.editedItem.grupo.$dirty) return errors;
      !this.$v.editedItem.grupo.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    filialErrors() {
      const errors = [];
      if (!this.$v.editedItem.filial.$dirty) return errors;
      !this.$v.editedItem.filial.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    razaoSocialErrors() {
      const errors = [];
      if (!this.$v.editedItem.razao_social.$dirty) return errors;
      !this.$v.editedItem.razao_social.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    cnpjErrors() {
      const errors = [];
      if (!this.$v.editedItem.cnpj.$dirty) return errors;
      !this.$v.editedItem.cnpj.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    enderecoErrors() {
      const errors = [];
      if (!this.$v.editedItem.endereco.$dirty) return errors;
      !this.$v.editedItem.endereco.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    cidadeErrors() {
      const errors = [];
      if (!this.$v.editedItem.cidade.$dirty) return errors;
      !this.$v.editedItem.cidade.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    estadoErrors() {
      const errors = [];
      if (!this.$v.editedItem.estado.$dirty) return errors;
      !this.$v.editedItem.estado.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    ieErrors() {
      const errors = [];
      if (!this.$v.editedItem.inscricao_estadual.$dirty) return errors;
      !this.$v.editedItem.inscricao_estadual.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    suframaErrors() {
      const errors = [];
      if (!this.$v.editedItem.suframa.$dirty) return errors;
      !this.$v.editedItem.suframa.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    cepErrors() {
      const errors = [];
      if (!this.$v.editedItem.cep.$dirty) return errors;
      !this.$v.editedItem.cep.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    formTitle() {
      return this.editedIndex === -1
        ? "Cadastro de Informações de Filial"
        : "Edição de Informações de Filial";
    },
  },

  methods: {
    initialize() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        ConfigApi.getFiliaisRelatorio(headers)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.desserts = response.data.filiais_relatorio;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    buscarFiliais() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.editedItem.grupo,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        DrpAPI.getFiliaisDrp(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);
            this.selects.filiais = response.data.filiais;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    buscarGrupos() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        ConfigApi.getGrupos(headers)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.selects.grupos = response.data.grupos;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    close() {
      this.dialog = false;
      this.editedItem = {};
      this.editedIndex = -1;
      this.$v.$reset();
    },

    editItem(item) {
      this.selects.filiais = [{
        id: item.idfilial,
        descricao: `Filial ${item.idfilial}`
      }];

      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.editedItem.filial = item.idfilial;
      this.dialog = true;
    },

    deleteItem(item){
      if (confirm("Deseja realmente remover o Item?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          filial: item.idfilial
        }

        this.$store.dispatch(
          "loading/addRequisicao",
          ConfigApi.deleteFilialRelatorio(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);
              this.initialize();
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },

    save() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          ConfigApi.setFiliaisRelatorio(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              this.close();
              this.initialize();
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },
  },
};
</script>

<style>
</style>
